<!--
    描述：项目合同
    日期：2022/9/26
    创建人：李家宝
-->
<template>
  <div>
    <div>
      <el-empty description="暂无数据" v-if="tableData.length == 0"></el-empty>
      <template v-else>
        <div>
          当前项目合同
          <span style="color: #0000FF">{{ tableData.length }}</span
          >份
        </div>
        <div class="mt10">
          <el-table
            :data="tableData"
            highlight-current-row
            row-key="id"
            border
            ref="table"
            style="width: 100%"
          >
            <el-table-column
              prop="contractCode"
              label="合同编号"
              align="center"
              show-overflow-tooltip
              width="160"
            ></el-table-column>
            <el-table-column
              prop="contractName"
              label="合同名称"
              show-overflow-tooltip
              width="260"
            >
            </el-table-column>
            <el-table-column
              label="合同创建时间"
              prop="createDate"
              show-overflow-tooltip
              align="center"
              width="180"
            >
            </el-table-column>
            <el-table-column
              label="签订对象"
              show-overflow-tooltip
              prop="bidderAddress"
              align="center"
              min-width="170"
            >
              <template slot-scope="scope">
                <span class="mr55">甲方：{{ scope.row.signAName }}</span>
                <span>乙方：{{ scope.row.signBName }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="contractStatus"
              label="状态"
              align="center"
              width="151"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.contractStatus == 0">待签署</span>
                <span v-if="scope.row.contractStatus == 1">签署中</span>
                <span v-if="scope.row.contractStatus == 2">已签署</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="120">
              <template slot-scope="scope">
                <el-button size="mini" @click="viewContract(scope.row)"
                  >查看合同</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!--分页-->
        <div class="w-table-footer">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="pageList"
            :page-size="pageSize"
            :total="total"
            layout="total, sizes, prev, pager, next, jumper"
          >
          </el-pagination>
        </div>

        <!--弹窗-->
        <el-dialog
          :visible.sync="auditShow"
          width="60%"
          center
          :title="currentRowData.contractName"
          :close-on-click-modal="false"
          @close="closeDialog"
        >
          <div class="dialog-box">
            <iframe
              width="100%"
              :src="url"
              frameborder="0"
              style="width: 100%; height: 100%"
            ></iframe>
          </div>
        </el-dialog>
      </template>
    </div>
  </div>
</template>

<script>
import { getContractPageList } from "api/modules/projectManagement";
import VUE_CONFIG from "../../../../../vue.config";
export default {
  name: "projectContract",
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      currentPage: 1, // 当前页码
      pageList: [10, 20, 50, 100], // 显示条数数组
      pageSize: 10, // 当前显示条数
      total: 0, // 当前总条数
      tableData: [], // 表格数据
      auditShow: false, // 审核弹窗的显隐
      btnLoading: false,
      currentRowData: {}, // 当前行数据
      url: ""
    };
  },
  methods: {
    // 获取列表数据
    getContractPageList() {
      let parameter = {
        current: this.currentPage,
        size: this.pageSize,
        subProjectId: this.rowData.businessId
      };
      getContractPageList(parameter).then(res => {
        if (res.operationCode == 1) {
          this.tableData = res.data.records;
          this.currentPage = parseInt(res.data.current);
          this.total = parseInt(res.data.total);
          this.pageSize = parseInt(res.data.size);
        }
      });
    },

    // close 审查弹框
    closeDialog() {
      this.auditShow = false;
    },

    // 切换显示条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.getContractPageList();
    },

    //切换当前页码
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getContractPageList();
    },

    // 查看合同
    viewContract(currentRowData) {
      this.currentRowData = currentRowData;
      this.auditShow = true;
      let uploadUrl = "";
      // 本地环境代理后无法直接获取路径
      if (process.env.VUE_APP_UPLOAD_URL == "/uploadApi") {
        uploadUrl = VUE_CONFIG.devServer.proxy["/uploadApi"].target;
      } else {
        uploadUrl = process.env.VUE_APP_UPLOAD_URL;
      }

      if (
        currentRowData.contractStatus == 0 ||
        currentRowData.contractStatus == 1
      ) {
        this.url =
          this.$previewUrl + uploadUrl + currentRowData.templateFileUrl;
      } else if (currentRowData.contractStatus == 2) {
        this.url =
          this.$previewUrl + uploadUrl + currentRowData.contractFilePath;
      }
    }
  },

  created() {},

  mounted() {}
};
</script>

<style scoped>
.el-button {
  background-color: #199ed8;
  color: white;
}
.w-table-footer {
  display: flex;
  justify-content: center;
  margin: 20px;
}
.dialog-box {
  height: 500px;
}
</style>
